<style lang="sass" scoped>
.p-main
    padding: 0
.fb
    padding: 35px 40px
    height: 100%
    .reasons
        margin-bottom: 30px
        text-align: left
        .radio-group
            margin: 0

    .submit-btn
        width: 200px
        margin-top: 20px

    .text-area
        width: 500px
        margin-bottom: 20px

</style>
<style lang="sass">
.fb
    .el-textarea
        textarea
            width: 498px
            height: 180px
            resize: none
</style>

<template lang="pug">
div
  .p-title 意见反馈
  .p-main
    .fb
      .reasons
        .radio-group(v-model="curReasonIdx")
          .radio(
            v-for="(item, i) in tabs" :key="i"
            :label="i+1" :class="{'cur':curReasonIdx == i+1}"
            @click="curReasonIdx=i+1"
          ) {{item}}
            .circle
              .black

      .text-area
        el-input(type="textarea" v-model="reason" placeholder="建议被采纳后，我们将会送一份惊喜给您" maxlength="200")
        .text-num {{reason.length}}
          span /200

      upload-image(:img-src.sync="imgSrc") 上传图片
        span.sub (小于5M)

      .submit-btn(
        :class="{'disable': !reason || reason.trim() == '' || curReasonIdx < 0}"
        @click="submit"
      ) 提交

</template>

<script>
import UploadImage from '../components/UploadImage'
export default {
    name: 'feedback',
    components: { UploadImage },
    data(){
        return {
            curReasonIdx: 1,
            tabs: [
                '产品建议',
                '程序错误'
            ],
            reason: '',
            imgSrc: ''
        }
    },
    methods: {
        async submit(){
            if(!this.reason || this.reason.trim() == '' || this.curReasonIdx < 0) return

            if(this.reason.length > 200) return this.messageTip('建议最多200个字符')

            let res = await this.fetch('/boss/feedback/v2/saveFeedback', {
                feedbackMsg: this.reason.trim(),
                feedbackType: this.curReasonIdx,
                feedbackUrls: [ this.imgSrc ]
            })
            if(res && res.code == this.successCode){
                this.messageTip(res.msg || '操作成功', 1)
                this.curReasonIdx = 1
                this.reason = ''
                this.imgSrc = ''

                tzx_czcPush('account', 'feebackSuccess')
            } else tzx_czcPush('account', 'feebackFail')
        }
    }
}
</script>

